import { useCallback, useEffect, useState } from "react";
import VideoPlayer from "../Components/VideoPlayer";
import fetchSubtitles from "../Services/FetchSubtitles";
import { Box, Container } from "@chakra-ui/react";
import FileSelector from "../Components/FileSelector";
import { CaptionOptions, VideoOptions, getCaptionOptions, getVideoOptions } from "../Types/Types";
import { convertSrtToVttUrl } from "../Utils/SrtUtils";

// This method tries to get a SRT first, if not found, try to get a VTT file
// By default, the it tries to match the name of the video file
// E.g. if video's name is video1.mp4, we will try video1.srt or video1.vtt
// Test videoUrl: 
//    http://localhost:8000/BigBuckBunny.mp4
// Test loading page with videoUrl: 
//    http://localhost:3000/?video-url=http%3A%2F%2Flocalhost%3A8000%2FBigBuckBunny.mp4
const getSubtitlesUrlFromVideoUrl = async (videoUrl: string): Promise<string | undefined> => {

  if (!videoUrl) {
    return undefined;
  }

  const subtitlesUrlSrt = videoUrl.replace(/(.*)\..*$/, '$1.srt');
  const subtitlesUrlVtt = videoUrl.replace(/(.*)\..*$/, '$1.vtt');

  console.log('subtitlesUrl:', subtitlesUrlSrt, subtitlesUrlVtt);

  let subtitlesUrl: string | undefined = undefined;
  let subtitlesData = await fetchSubtitles(subtitlesUrlSrt);
  console.log("subtitlesData:", subtitlesData);

  try {
    if (subtitlesData !== undefined) {
      subtitlesUrl = convertSrtToVttUrl(subtitlesData)
    }
    else {
      let subtitlesData = await fetchSubtitles(subtitlesUrlVtt);
      if (subtitlesData !== undefined) {
        const vttBlob = new Blob([subtitlesData], { type: 'text/vtt' });
        subtitlesUrl = URL.createObjectURL(vttBlob);
      }
    }
  }
  catch (error) {
    console.error('Unable to convert / build subtitlesUrl');
    subtitlesUrl = undefined;
  }

  return subtitlesUrl;
}

const HomePage = () => {

  const [videoOptions, setVideoOptions] = useState<VideoOptions>();
  const [captionOptions, setCaptionOptions] = useState<CaptionOptions[]>();
  const [videoUrl, setVideoUrl] = useState<string>();
  const [videoPlayerKey, setVideoPlayerKey] = useState<number>(1);
  const [isFileSelectorOpen, setIsFileSelectorOpen] = useState<boolean>(true);

  // We can also accept video-url in the URL as a parameter
  const queryParameters = new URLSearchParams(window.location.search)
  const paramVideoUrl = queryParameters.get("video-url")

  useEffect(() => {
    if (paramVideoUrl) {
      setVideoUrl(paramVideoUrl);
    }
  }, [paramVideoUrl]);



  const handleLoadMovie = useCallback(async () => {
    if (!videoUrl) {
      return;
    }

    const videoOptions = getVideoOptions(videoUrl);
    setVideoOptions(videoOptions);

    const subtitlesUrl = await getSubtitlesUrlFromVideoUrl(videoUrl);

    if (subtitlesUrl === undefined) {
      setCaptionOptions([]);
    }
    else {
      const captionOptions = getCaptionOptions(subtitlesUrl);
      setCaptionOptions([captionOptions]);
    }

    setIsFileSelectorOpen(false);
    setVideoPlayerKey((prevKey) => prevKey + 1);

  }, [videoUrl])

  return (
    <>
      <Container maxW='100%' >
        <FileSelector
          videoUrl={videoUrl}
          setVideoUrl={setVideoUrl}
          handleLoadMovie={handleLoadMovie}
          isFileSelectorOpen={isFileSelectorOpen}
          setIsFileSelectorOpen={setIsFileSelectorOpen} />
        <VideoPlayer
          key={videoPlayerKey}
          videoOptions={videoOptions}
          captionOptions={captionOptions} />
        <Box minHeight='5'></Box>
      </Container>

    </>
  );
}

export default HomePage;